import OrganizationApi from 'entities/organization/api';

import { useQuery } from '../useQuery';

import Organization from './model';

export const useCompanies = () =>
  useQuery(() => OrganizationApi.fetchCompanies().toPromise() as Promise<Organization[]>, []);
